import ModeloTanqueService from "@/services/ModeloTanqueService";

export const actions = {
  cadastrarModeloTanque: ({ commit, dispatch }) => {
    commit("setModeloTanque", {
      id: "",
      modelo: "",
      foto_url: "",
      foto_path: "",
    }),
      dispatch("setModalCadastroModeloTanque", true);
  },
  listarModeloTanque: ({ commit }, data) => {
    commit("setOverlay", true);
    ModeloTanqueService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModelosTanques", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  visualizarModeloTanque: ({ commit, dispatch }, data) => {
    commit("setModeloTanque", { ...data });
    dispatch("setModalCadastroModeloTanque", true);
  },
  async salvarModeloTanque({ commit, dispatch }, data) {
    commit("setOverlay", true);
    await ModeloTanqueService.salvar(data)
      .then((res) => {
        commit("addModeloTanque", res.data);
        commit("setOverlay", false);
        commit("snackbarSuccess", "Registro cadastrado.");
        dispatch("setModalCadastroModeloTanque", false);
      })
      .catch((e) => {
        console.log(e);
        // if (e.response.status == 422) {
        //   commit("alertError", e.response.data.errors);
        // }
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  async atualizarModeloTanque({ commit, dispatch }, data) {
    commit("setOverlay", true);
    await ModeloTanqueService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarInfo", "Registro atualizado.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
  excluirModeloTanque: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    dispatch("setModalExcluirModeloTanque", false);
    dispatch("setModalCadastroModeloTanque", false);
    ModeloTanqueService.excluir(data.id)
      .then((res) => {
        commit("removeModeloTanque", data);
        commit("setOverlay", false);
        commit("snackbarError", "Registro excluído.");
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao excluir.");
      });
  },
  setModalCadastroModeloTanque: ({ commit }, status) => {
    commit("setModalCadastroModeloTanque", false);
    setTimeout(() => {
      commit("setModalCadastroModeloTanque", status);
    }, 100);
  },
  setModalExcluirModeloTanque: ({ commit }, status) => {
    commit("setModalExcluirModeloTanque", false);
    setTimeout(() => {
      commit("setModalExcluirModeloTanque", status);
    }, 100);
  },
};

export default {};
